import React from 'react';
import {
  Container,
  Typography,
  Grid,
  Paper,
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  Security as SecurityIcon,
  VerifiedUser as VerifiedUserIcon,
  Lock as LockIcon,
  Report as ReportIcon,
  Shield as ShieldIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';

const Safety = () => {
  const { t } = useTranslation();

  const safetyFeatures = [
    {
      icon: <VerifiedUserIcon color="primary" />,
      title: t('safety.features.verification.title'),
      description: t('safety.features.verification.description')
    },
    {
      icon: <LockIcon color="primary" />,
      title: t('safety.features.privacy.title'),
      description: t('safety.features.privacy.description')
    },
    {
      icon: <ShieldIcon color="primary" />,
      title: t('safety.features.security.title'),
      description: t('safety.features.security.description')
    }
  ];

  const safetyTips = [
    {
      title: t('safety.tips.meeting.title'),
      items: t('safety.tips.meeting.items', { returnObjects: true })
    },
    {
      title: t('safety.tips.payment.title'),
      items: t('safety.tips.payment.items', { returnObjects: true })
    },
    {
      title: t('safety.tips.communication.title'),
      items: t('safety.tips.communication.items', { returnObjects: true })
    }
  ];

  return (
    <>
      <SEO 
        title={t('safety.title')}
        description={t('safety.description')}
      />
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          {t('safety.title')}
        </Typography>
        <Typography variant="subtitle1" color="text.secondary" align="center" sx={{ mb: 6 }}>
          {t('safety.subtitle')}
        </Typography>

        <Grid container spacing={4}>
          {safetyFeatures.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Paper sx={{ p: 3, height: '100%' }}>
                <Box sx={{ textAlign: 'center', mb: 2 }}>
                  {feature.icon}
                </Box>
                <Typography variant="h6" gutterBottom align="center">
                  {feature.title}
                </Typography>
                <Typography color="text.secondary" align="center">
                  {feature.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 6 }}>
          <Typography variant="h4" gutterBottom align="center">
            {t('safety.tips.title')}
          </Typography>
          <Grid container spacing={4}>
            {safetyTips.map((section, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Paper sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    {section.title}
                  </Typography>
                  <List>
                    {section.items.map((item, itemIndex) => (
                      <ListItem key={itemIndex}>
                        <ListItemIcon>
                          <SecurityIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText primary={item} />
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Typography variant="h5" gutterBottom>
            {t('safety.report.title')}
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            {t('safety.report.description')}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
            <ReportIcon color="error" />
            <Typography variant="body1">
              {t('safety.report.contact')}
            </Typography>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default Safety;